module.exports = __webpack_public_path__ + "static/media/12_portrait.d8fcdf7e.jpg";